/* - ---conversationsfield structure---
> conversations(collection) > conversationId(document) field structure
"adId"(advert id), 
"adTitle"(advert title), 
"coverImage"(advert cover image adress), 
"createdAt", "lastMessage"(last sending massage), 
"lastMessageRead"(boolean), 
"lastMessageSenderId", 
"lastMessageTime",
"participants" (Array)
"messages"(collection)
-------------------------
> ---messages field structure---
> conversations(collection) > conversationId(document) > messages(collection) > messageId(document) 
"createdAt",
"isRead"(boolean),
"message"(message body),
"senderEmail",
"senderId",
"senderPhotoURL"
*/
/* eslint-disable */
import { ref } from 'vue'
import { 
  collection, 
  query, 
  orderBy, 
  onSnapshot, 
  updateDoc,
  doc,
  where,
  increment,
  getDocs,
  getDoc,
  writeBatch
} from 'firebase/firestore'
import { db } from '../firebase'
import { getAuth } from 'firebase/auth'

// Global aktif listener'ları tutan bir Map tanımlıyoruz.
const activeListeners = new Map();

// Fonksiyon çağrı sayısını takip etmek için modül düzeyinde bir sayaç
let listenToMessagesCallCount = 0;

export const useMessages = () => {
  const messages = ref([])
  const error = ref(null)
  const loading = ref(false)
  const isPending = ref(false)

  // Yeni fonksiyon
  const removeFromUnreadMessages = async (messageIds, batch) => {
    const auth = getAuth();
    if (!auth.currentUser) return;

    try {
      const unreadMessagesRef = doc(db, 'unread_messages', auth.currentUser.uid);
      const unreadMessagesDoc = await getDoc(unreadMessagesRef);
      
      if (unreadMessagesDoc.exists()) {
        const unreadMessageIds = unreadMessagesDoc.data().unreadMessageId || [];
        
        // Debug log ekle
        // console.log('Mevcut unread mesajlar:', unreadMessageIds);
        // console.log('Silinecek mesaj ID(ler):', messageIds);
        
        const messageIdArray = Array.isArray(messageIds) ? messageIds : [messageIds];
        
        let hasChanges = false;
        messageIdArray.forEach(messageId => {
          const index = unreadMessageIds.indexOf(messageId);
          if (index !== -1) {
            unreadMessageIds.splice(index, 1);
            //console.log(`Unread mesaj silindi: ${messageId}`);
            hasChanges = true;
          } else {
            //console.log(`Mesaj ID bulunamadı: ${messageId}`);
          }
        });

        if (hasChanges) {
          batch.update(unreadMessagesRef, {
            unreadMessageId: unreadMessageIds
          });
        } else {
          //console.log('Hiç değişiklik yapılmadı');
        }
      } else {
        //console.log('Unread messages dokümanı bulunamadı');
      }
    } catch (error) {
      console.error('Unread messages güncellenirken hata:', error);
    }
  };

  const markAllMessagesAsRead = async (conversationId) => {
    const auth = getAuth();
    if (!auth.currentUser || isPending.value) return;
    isPending.value = true;

    try {
      const conversationRef = doc(db, 'conversations', conversationId);
      const conversationDoc = await getDoc(conversationRef);
      
      if (!conversationDoc.exists()) return;
      
      const messagesRef = collection(db, 'conversations', conversationId, 'messages');
      
      // lastReadTime ve createdAt kontrolünü kaldıralım
      const unreadSnapshot = await getDocs(query(
        messagesRef,
        where('isRead', '==', false), // Okunmamış mesajlar
        where('senderId', '!=', auth.currentUser.uid) // Karşı tarafın mesajları
      ));

      if (unreadSnapshot.size > 0) {
        const batch = writeBatch(db);
        
        // Her bir okunmamış mesajı güncelle
        unreadSnapshot.docs.forEach(doc => {
          batch.update(doc.ref, { isRead: true });
        });

        // Conversation'ı güncelle
        batch.update(conversationRef, { 
          hasUnread: false,
          lastMessageRead: true,
          lastReadTime: new Date()
        });

        // Yeni fonksiyonu kullan
        await removeFromUnreadMessages(
          unreadSnapshot.docs.map(doc => doc.id),
          batch
        );

        await batch.commit();
        //console.log(`${unreadSnapshot.size} mesaj okundu olarak işaretlendi.`);
      }

    } catch (err) {
      console.error('Error marking messages as read:', err);
    } finally {
      isPending.value = false;
    }
  };

  const listenToMessages = (conversationId, onNewMessage) => {
    listenToMessagesCallCount++;
    const auth = getAuth();
    if (!conversationId) {
      error.value = 'Geçersiz konuşma ID';
      return;
    }
    
    // Eğer aynı conversationId için zaten bir dinleyici varsa onu unsubscribe et.
    if (activeListeners.has(conversationId)) {
      activeListeners.get(conversationId)(); // unsubscribe çağrısı
      activeListeners.delete(conversationId);
      //console.log(`Önceki dinleyici sonlandırıldı: ${conversationId}`);
    }

    loading.value = true;
    messages.value = [];

    // query değişken adını messagesQuery olarak değiştirelim
    const messagesQuery = query(
      collection(db, 'conversations', conversationId, 'messages'),
      orderBy('createdAt', 'asc')
    );

    // İlk mesajları yükleme kısmına kontrol ekleyelim
    getDocs(messagesQuery).then(async snapshot => {
      const batch = writeBatch(db);
      let hasUnreadMessages = false;
    
      // Mesajları işle ve okunmamışları kontrol et
      for (const doc of snapshot.docs) {
        const message = { id: doc.id, ...doc.data() };
        
        // Eğer mesaj okunmamış ve karşı taraftan geldiyse
        if (!message.isRead && 
            message.senderId !== auth.currentUser?.uid && 
            !processedMessages.has(message.id)) {
          
          processedMessages.add(message.id);
          hasUnreadMessages = true;
          
          // Mesajı okundu olarak işaretle
          batch.update(doc.ref, { isRead: true });
          
          // unread_messages'dan kaldır
          await removeFromUnreadMessages(message.id, batch);
        }
      }
    
      // Eğer okunmamış mesaj varsa conversation'ı güncelle
      if (hasUnreadMessages) {
        const conversationRef = doc(db, 'conversations', conversationId);
        batch.update(conversationRef, {
          lastMessageRead: true,
          lastReadTime: new Date()
        });
        
        await batch.commit();
      }
    
      messages.value = snapshot.docs.map(doc => ({ 
        id: doc.id, 
        ...doc.data() 
      }));
      
      loading.value = false;
      if (onNewMessage) onNewMessage('initial');
    }).catch(err => {
      console.error('İlk mesajlar yüklenirken hata:', err);
      loading.value = false;
    });

    // Dinleyici başlangıcında işlenen mesajları tutan bir Set oluşturun.
    const processedMessages = new Set();

    // Yeni mesajları dinle
    const unsubscribe = onSnapshot(messagesQuery, (snapshot) => {
      snapshot.docChanges().forEach(async (change) => {
        if (change.type === 'added' || change.type === 'modified') {
          const newMessage = { id: change.doc.id, ...change.doc.data() };

          const index = messages.value.findIndex(m => m.id === newMessage.id);
          if (index !== -1) {
            messages.value.splice(index, 1, newMessage);
          } else {
            messages.value = [...messages.value, newMessage];
          }
          
          messages.value = [...messages.value].sort((a, b) => 
            (a.createdAt?.toMillis() || 0) - (b.createdAt?.toMillis() || 0)
          );

          // Yeni mesajları dinle kısmında
          if (change.type === 'added' && 
              newMessage.senderId !== auth.currentUser?.uid && 
              !newMessage.isRead &&
              !processedMessages.has(newMessage.id)) {

            // console.log('Yeni okunmamış mesaj tespit edildi:', {
            //   messageId: newMessage.id,
            //   senderId: newMessage.senderId,
            //   currentUser: auth.currentUser?.uid,
            //   isRead: newMessage.isRead,
            //   isProcessed: processedMessages.has(newMessage.id)
            // });

            processedMessages.add(newMessage.id);

            try {
              const batch = writeBatch(db);
              //console.log('Batch işlemi başlıyor...');
              
              // Gecikme ekleyelim (1 saniye)
              //console.log('Unread mesajların güncellenmesi için bekleniyor...');
              await delay(1000);
              
              // Debug kontrolü: unread_messages dokümanını kontrol et
              const unreadMessagesRef = doc(db, 'unread_messages', auth.currentUser.uid);
              const unreadMessagesDoc = await getDoc(unreadMessagesRef);
              console.log('Mevcut unread_messages durumu:', unreadMessagesDoc.exists() ? unreadMessagesDoc.data() : 'Doküman yok');

              // Mesajı okundu olarak işaretle
              batch.update(change.doc.ref, { isRead: true });
              
              console.log('removeFromUnreadMessages çağrılıyor...');
              await removeFromUnreadMessages(newMessage.id, batch);
              
              console.log('Batch commit ediliyor...');
              await batch.commit();
              console.log('Batch işlemi tamamlandı');
              
            } catch (err) {
              console.error('Hata detayı:', err);
            }
          }

          if (onNewMessage && change.type === 'added') {
            onNewMessage('new', newMessage);
          }
        }
      });
    });

    // Aktif listener'ı kaydeder ve konsola basarız
    activeListeners.set(conversationId, unsubscribe);
    //console.log('Aktif listenerlar:', Array.from(activeListeners.keys()));

    // İstemediğiniz zaman bu unsubscribe fonksiyonunu çağırarak dinleyiciyi sonlandırabilirsiniz.
    return unsubscribe;
  };

  // Yeni delay utility fonksiyonu ekleyelim
  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  return { 
    messages, 
    error, 
    loading, 
    listenToMessages,
    markAllMessagesAsRead,
    removeFromUnreadMessages  // İhtiyaç duyulursa dışarı açılabilir
  }
}